
import { createReducer } from 'redux-delta';
import { stateAgents as actions } from './';

const tutorialReducer = createReducer({ tutorialStatus: null, error: null }, [
  actions.startTutorial.case((_, tutorialStatus) => ({ tutorialStatus })),
  actions.updateTutorialStatus.case((_, tutorialStatus) => ({ tutorialStatus })),
  actions.finishTutorial.case((_, tutorialStatus) => ({ tutorialStatus })),
  actions.abortTutorial.case((_, tutorialStatus) => ({ tutorialStatus })),
  actions.tutorialError.case((_, error) => ({ tutorialStatus: null, error })),
])

export default tutorialReducer



// WEBPACK FOOTER //
// ./src/store/tutorial/reducer.js